import React, { useEffect, useRef, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./PPClasses.css";
import { Modal } from "react-bootstrap";
import Header from "../../Header/Header";
import Spinner from "../../Spinner/Spinner";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { handleException } from "../../../app/util/util";
import { post, get, put } from "../../../app/shared/http";
import loaderColors1 from "../../Spinner/loaderColors1.gif";
import PPWelcomeImage from "../PracticePerfectClasses/PPProfessorWelcomePopup.png";
import {
  withAuth,
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
export function PPClasses() {
  const classNameRef = useRef(null);
  const classSemesterRef = useRef(null);
  const classYearRef = useRef(null);
  const CLASS_NAME_ERROR_ID = "class-name-error";
  const CLASS_SEMESTER_ERROR_ID = "class-semester-error";
  const CLASS_YEAR_ERROR_ID = "class-year-error";
  const { isbn } = useParams();
  const history = useHistory();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const ppIsbn =
    isbn && isbn !== "undefined" ? isbn : localStorage.getItem("bookIsbn");
  const ppQuizResetPopupFocus = useRef(null);
  const [ppClassId, setPPClassId] = useState();
  const [className, setClassName] = useState("");
  const [ppClassInfo, setPPClassInfo] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [classSemCount, setClassSemCount] = useState();
  const [yearCollection, setYearCollection] = useState();
  const [classSemester, setClassSemester] = useState("");
  const [classNameCount, setClassNameCount] = useState();
  const [classDescCount, setClassDescCount] = useState();
  const [errClassYear, setErrClassYear] = useState(false);
  const [errClassName, setErrClassName] = useState(false);
  const [ppClassesPageInfo, setPpClassesPageIngo] = useState();
  const [classDescription, setClassDescription] = useState("");
  const [showPPClassPopUp, setShowPPClassPopUp] = useState(false);
  const [errClassSemester, setErrClassSemester] = useState(false);
  const [isPPClassPageLoad, setIsPPClassPageLoad] = useState(true);
  const [classYear, setClassYear] = useState(new Date().getFullYear());
  const [isResetNotificationData, setResetNotificationData] = useState();
  const [showPPClassEditPopUp, setshowPPClassEditPopUp] = useState(false);
  const [showPPClassDeletePopUp, setshowPPClassDeletePopUp] = useState(false);
  const [isShowProfQuizResetPopup, setShowProfQuizResetPopup] = useState(false);
  const [isShowProfessorWelcomePopup, setIsShowProfessorWelcomePopup] =
    useState(false);
  const [
    isShowProfessorWelcomePopupCheckbox,
    setIsShowProfessorWelcomePopupCheckbox,
  ] = useState(false);
  useEffect(() => {
    if (isShowProfQuizResetPopup) {
      ppQuizResetPopupFocus.current.focus();
    }
  }, [isShowProfQuizResetPopup]);
  const getPPvideoPagedetails = async () => {
    let reqData = { productISBN: ppIsbn };
    post("/PP/get-PPproductDetails", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else {
          if (data.ValidityStatus === "Expired") {
            localStorage.setItem("PPException", data.ValidityStatus);
            window.location.replace(window.location.origin + "/invalidUrl");
            return false;
          }
          localStorage.removeItem("PPException");
          setPpClassesPageIngo(data);
          getPPClasses(data.SATagId);
          localStorage.setItem("ppLandingInfo", JSON.stringify(data));
          localStorage.setItem("ppProductName", data.ProductName);
          localStorage.setItem("ppProductTagId", data.SATagId);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getUserConfigurations = async () => {
    get(
      "/PP/Professor/userConfigurationsByIdAndKey?key=PROF_WELCOME_MSG&userId=" +
        userVO.userId,
      "qpAPI",
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else if (parseInt(data.value) <= 2) {
          setIsShowProfessorWelcomePopup(true);
          updateUserConfigurations(parseInt(data.value) + 1);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updateUserConfigurations = async (count) => {
    let reqData = {
      userConfiguration: {
        value: count,
        userId: userVO.userId,
        key: "PROF_WELCOME_MSG",
        additionalDetails: null,
      },
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
      },
    };
    put("/PP/Professor/updateUserConfiguration", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const hideProfessorWelcomePopup = () => {
    setIsShowProfessorWelcomePopup(false);
    if (isShowProfessorWelcomePopupCheckbox) {
      updateUserConfigurations(3);
    }
  };
  const getPPClasses = (ppTagId) => {
    let reqData = {
      ppClassVO: { ppguidId: ppTagId, professorUserId: userVO.userId },
    };
    post("/PP/Professor/getPPClasses", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setIsPPClassPageLoad(false);
          setPPClassInfo(data.ppClassList);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleAddClassBtn = () => {
    handleYearCollection();
    setClassName("");
    setClassSemester("");
    setClassDescription("");
    setShowPPClassPopUp(true);
    setClassSemCount("0 / 20");
    setClassNameCount("0 / 100");
    setClassDescCount("0 / 300");
  };
  const handleClassCancelBtn = () => {
    setIsEditing(false);
    setShowPPClassPopUp(false);
    discardAddClassPopupData();
  };
  const handlePPClassName = (targetValue, types) => {
    if (types === "ClassName") {
      setClassName(targetValue.trimStart());
      setClassNameCount(targetValue.length + "/ 100");
    } else if (types === "ClassSemester") {
      setClassSemester(targetValue.trimStart());
      setClassSemCount(targetValue.length + "/ 20");
    } else if (types === "ClassYear") {
      setClassYear(targetValue);
    } else {
      setClassDescription(targetValue);
      setClassDescCount(targetValue.length + "/ 300");
    }
  };
  const handlePPClassSubmitBtn = () => {
    const hasClassNameError = className.trim() === "";
    const hasClassSemesterError = classSemester.trim() === "";
    const hasClassYearError = classYear === "";

    setErrClassName(hasClassNameError);
    setErrClassSemester(hasClassSemesterError);
    setErrClassYear(hasClassYearError);

    if (hasClassNameError || hasClassSemesterError || hasClassYearError) {
      setTimeout(() => {
        if (hasClassNameError && classNameRef.current) {
          classNameRef.current.focus();
        } else if (hasClassSemesterError && classSemesterRef.current) {
          classSemesterRef.current.focus();
        } else if (hasClassYearError && classYearRef.current) {
          classYearRef.current.focus();
        }
      }, 0);

      return;
    }

    if (isEditing) {
      setIsEditing(false);
      setShowPPClassPopUp(false);
      setshowPPClassEditPopUp(true);
    } else {
      setIsEditing(false);
      setIsPPClassPageLoad(true);

      let reqData = {
        ppClassVO: {
          ppYear: classYear,
          ppClassName: className.trim(),
          ppSemester: classSemester.trim(),
          ppClassDescription: classDescription,
          ppguidId: localStorage.getItem("ppProductTagId"),
        },
      };

      post("/PP/Professor/createPPClass", reqData, "qpAPI")
        .then(handleResponse)
        .then((response) => response.json())
        .then(handleJwtTokenForKeppMeLoggedIn)
        .then((data) => {
          if (data) {
            setShowPPClassPopUp(false);
            setIsPPClassPageLoad(false);
            getPPClasses(localStorage.getItem("ppProductTagId"));
            discardAddClassPopupData();
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });

      setErrClassName(false);
      setErrClassYear(false);
      setErrClassSemester(false);
    }
  };
  const handleYearCollection = () => {
    let YearCol = [];
    for (
      let i = new Date().getFullYear() - 1;
      i < new Date().getFullYear() + 6;
      i++
    ) {
      YearCol.push(i);
    }
    setYearCollection(YearCol);
  };
  const discardAddClassPopupData = () => {
    setClassName("");
    setClassSemester("");
    setErrClassName(false);
    setErrClassYear(false);
    setClassDescription("");
    setErrClassSemester(false);
    setClassYear(new Date().getFullYear());
  };
  const deletePPClass = () => {
    setIsPPClassPageLoad(true);
    let reqtData = {
      ppClassVO: {
        ppYear: null,
        ppSemester: null,
        ppClassName: null,
        ppClassId: ppClassId,
        ppClassDescription: null,
        ppguidId: localStorage.getItem("ppProductTagId"),
      },
    };
    post("/PP/Professor/DeletePPClass", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setshowPPClassDeletePopUp(false);
          getPPClasses(localStorage.getItem("ppProductTagId"));
          setIsPPClassPageLoad(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updatePPClass = () => {
    setIsPPClassPageLoad(true);
    let reqtData = {
      ppClassVO: {
        ppYear: classYear,
        ppClassId: ppClassId,
        ppClassName: className,
        ppSemester: classSemester,
        ppClassDescription: classDescription,
        ppguidId: localStorage.getItem("ppProductTagId"),
      },
    };
    post("/PP/Professor/PPClassUpdate", reqtData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setShowPPClassPopUp(false);
          setshowPPClassEditPopUp(false);
          getPPClasses(localStorage.getItem("ppProductTagId"));
          setIsPPClassPageLoad(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
    setClassName("");
    setClassSemester("");
    setClassDescription("");
  };
  useEffect(() => {
    setClassSemCount("0 / 20");
    setClassNameCount("0 / 100");
    setClassDescCount("0 / 300");
  }, []);
  useEffect(() => {
    getUserConfigurations();
    getPPvideoPagedetails();
    getPPRestNotification();
  }, []);
  useEffect(() => {
    if (isResetNotificationData != undefined) {
      updatePPRestNotification();
    }
  }, [isResetNotificationData]);
  const showToastMessage = () => {
    toast.info("Access Code Copied to Clipboard", {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  };
  const handlePPClassStudentDetailsPage = (ppClassInfo) => {
    history.push(`/pp-classes/${isbn}/pp-studentsdetails`, { ppClassInfo });
  };
  const getPPRestNotification = () => {
    get("/admin/RestNotification?key=pp&user_Id=" + userVO.userId, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else if (data.status == true) {
          setShowProfQuizResetPopup(true);
          setResetNotificationData(data.NotificationList);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updatePPRestNotification = (notifyValue) => {
    let collectionOfRNjson = [];
    isResetNotificationData &&
      isResetNotificationData.forEach((notificationVal) => {
        let RNjson = {
          userId: userVO.userId,
          key_name: notificationVal.key_name,
          notificationId: notificationVal.NotificationId,
          value: notifyValue === 3 ? 3 : parseInt(notificationVal.value) + 1,
        };
        collectionOfRNjson.push(RNjson);
      });
    let reqData = {
      notificationList: collectionOfRNjson,
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: userVO.keepMeLoggedInFlag,
      },
    };
    put("/admin/updateRestNotification", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const DownloadStudentInstructions = (classCode) => {
    get(`/admin/studentInstructions?classcode=${classCode}`, "qpAPI")
      .then(handleResponse)
      .then((response) => response.blob())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((blob) => {
        if (
          blob.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = `${classCode}_Note_To_Students.docx`;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          alert("Exception Occurs. Please try again later");
        }
      })
      .catch((error) => {
        console.error("There is a problem with your fetch operation:", error);
      });
  };
  return (
    <>
      <Spinner
        loading={isPPClassPageLoad}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <Header userVO={userVO} pageName="PPClasses" isbn={ppIsbn}></Header>
      <div className="container">
        <div className="card ppClassContainerSection">
          <div className="card-body ppvContainerCard">
            <div className="row">
              <div className="col-12 p-0">
                {ppClassesPageInfo && (
                  <div className="ppvLogoContainer pt-4">
                    <p>
                      <span className="ppvCommonStyle ppvLogoBoldText">
                        PracticePerfect
                      </span>
                      <span className="ppvCommonStyle ppvLogoText">
                        {ppClassesPageInfo.ProductName}
                      </span>
                    </p>
                  </div>
                )}
                <>
                  <div className="pt-2">
                    <h4 className="ppClassesTitle mb-1">Classes</h4>
                    <p className="ppClassDescp h6">
                      Create classes to view and analyze your students' quiz
                      progress.{" "}
                      <a
                      className="underline"
                        href="https://support.aspenpublishing.com/hc/en-us/articles/18000255291540-How-do-I-track-the-progress-of-my-students-on-quizzes-"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        Learn more
                      </a>
                    </p>
                    <button
                      className="btn btn-primary rounded-0 mt-2 ppClassesAddBtn p-1"
                      onClick={() => handleAddClassBtn()}
                    >
                      Add New Class
                    </button>
                  </div>
                  <ToastContainer />
                  {ppClassInfo != undefined
                    ? ppClassInfo.map((ppClasses) => {
                        return (
                          <>
                            <div className="ppClassesContainer mt-4 p-3">
                              <div className="row">
                                <div className="col-xl-7 col-lg-7 col-md-5 col-sm-12 col-12">
                                  <a
                                    href="#"
                                    className="ppClassTitle mb-2 d-inline-block"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handlePPClassStudentDetailsPage(
                                        ppClasses,
                                      );
                                    }}
                                  >
                                    {ppClasses.ppClassName}{" "}
                                    {ppClasses.ppSemester} {ppClasses.ppYear}
                                  </a>
                                </div>
                                <div className="col-xl-5 col-lg-5 col-md-7 col-sm-12 col-12 pr-0">
                                  <div className="row w-100">
                                    <div className="col-xl-5 col-lg-4 col-md-5 col-sm-4 col-4 text-xl-right text-lg-right text-md-right text-left pr-xl-3 pr-lg-0 pr-md-3 pr-0">
                                      <span className="ppClassProfCode pr-0">
                                        Class Code:
                                      </span>
                                    </div>
                                    <div className="col-xl-7 col-lg-8 col-md-7 col-sm-8 col-8 pl-xl-0 pl-lg-2 pl-md-0 pl-0 pr-0">
                                      <div className="d-inline-flex">
                                        <input
                                          type="text"
                                          className="ppClassProfCodeIn rounded-0 w-100"
                                          aria-label={ppClasses.ppClassCode}
                                          aria-labelledby={`class-code-label-${ppClasses.ppClassId}`}
                                          value={ppClasses.ppClassCode}
                                          readOnly
                                        />
                                        <button
                                          className="ppClassProfCodeCopyBtn"
                                          aria-label="Copy"
                                          onClick={() => {
                                            showToastMessage();
                                            navigator.clipboard.writeText(
                                              ppClasses.ppClassCode,
                                            );
                                          }}
                                        >
                                          Copy
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                {ppClasses.ppClassDescription && (
                                  <p className="ppClassDescp mt-2">
                                    {ppClasses.ppClassDescription}
                                  </p>
                                )}
                                <div className="mt-2 text-right">
                                  <button
                                    className="btn btn-primary rounded-0 ppClassStdInsBtn  mr-2"
                                    onClick={() =>
                                      DownloadStudentInstructions(
                                        ppClasses.ppClassCode,
                                      )
                                    }
                                  >
                                    Student Instructions{" "}
                                    <i
                                      className="fa fa-download pl-1"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <button
                                    className="btn btn-primary rounded-0 ppClassEditBtn mr-2"
                                    onClick={() => [
                                      setShowPPClassPopUp(true),
                                      setIsEditing(true),
                                      setPPClassId(ppClasses.ppClassId),
                                      setClassName(ppClasses.ppClassName),
                                      setClassSemester(ppClasses.ppSemester),
                                      setClassDescription(
                                        ppClasses.ppClassDescription,
                                      ),
                                      setClassYear(ppClasses.ppYear),
                                      setClassNameCount(
                                        ppClasses.ppClassName.length + "/ 100",
                                      ),
                                      setClassSemCount(
                                        ppClasses.ppSemester.length + "/ 20",
                                      ),
                                      setClassDescCount(
                                        ppClasses.ppClassDescription.length +
                                          "/ 300",
                                      ),
                                      handleYearCollection(),
                                    ]}
                                  >
                                    Edit
                                    <i
                                      className="fa fa-pencil-square-o pl-1"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <button
                                    className="btn btn-primary rounded-0 ppClassDeleteBtn"
                                    onClick={() => {
                                      setshowPPClassDeletePopUp(true);
                                      setPPClassId(ppClasses.ppClassId);
                                    }}
                                  >
                                    Delete{" "}
                                    <i
                                      className="fa fa-trash pl-1"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null}
                  <Modal
                    className="modal fade"
                    show={showPPClassPopUp}
                    onHide={() => setShowPPClassPopUp(false)}
                    size="lg"
                    aria-label="Add a Class"
                    // aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  >
                    <div className="ppClassAddPopUp">
                      <span
                        id="contained-modal-title-vcenter"
                        className="sr-only"
                      >
                        Dialog Add a Class
                      </span>
                      <div className="mb-3 mt-4">
                        <label
                          className="ppClassPopUpTxt"
                          htmlFor="input_class_name"
                        >
                          Class Name<span className="delePopup-colRed">*</span>
                        </label>
                        <input
                          id="input_class_name"
                          data-testid="input_class_name"
                          type="text"
                          className="className ppClassNameInBox form-control rounded-0"
                          maxlength="100"
                          value={className}
                          onChange={(e) =>
                            handlePPClassName(e.target.value, "ClassName")
                          }
                          required
                          aria-required="true"
                          ref={classNameRef}
                          aria-invalid={errClassName ? "true" : "false"}
                          aria-describedby={
                            errClassName ? CLASS_NAME_ERROR_ID : undefined
                          }
                        />
                        {errClassName && (
                          <span
                            className="delePopup-colRed"
                            id={CLASS_NAME_ERROR_ID}
                            role="alert"
                          >
                            Class name is required
                          </span>
                        )}
                        <div className="classNameCnt countView">
                          <span
                            id="inputCountTextclss"
                            className="classNameValCountText inputCountTextclss"
                          >
                            {classNameCount}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7">
                          <div className="row">
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-5">
                              <label
                                className="ppClassPopUpTxt"
                                htmlFor="input_semester_term"
                              >
                                Semester/Term
                                <span className="delePopup-colRed">*</span>
                              </label>
                            </div>
                            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-12 pl-xl-0 pl-lg-0 pl-md-0 pl-3 pr-0">
                              <input
                                ref={classSemesterRef}
                                id="input_semester_term"
                                data-testid="input_semester_term"
                                required
                                aria-required="true"
                                aria-invalid={
                                  errClassSemester ? "true" : "false"
                                }
                                aria-describedby={
                                  errClassSemester
                                    ? CLASS_SEMESTER_ERROR_ID
                                    : undefined
                                }
                                type="text"
                                className="ppClassNameInBox form-control rounded-0 w-80"
                                maxLength="20"
                                value={classSemester}
                                onChange={(e) =>
                                  handlePPClassName(
                                    e.target.value,
                                    "ClassSemester",
                                  )
                                }
                              />
                              {errClassSemester && (
                                <span
                                  id={CLASS_SEMESTER_ERROR_ID}
                                  className="delePopup-colRedSem"
                                  role="alert"
                                >
                                  Semester/Term is required
                                </span>
                              )}
                              <div className="classNameCnt countView ">
                                <span className="classNameValCountText inputCountTextsem">
                                  {classSemCount}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 pr-0">
                          <div className="row">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-4 pr-0">
                              <label
                                className="ppClassPopUpTxt"
                                htmlFor="select_year"
                              >
                                Year<span className="delePopup-colRed">*</span>
                              </label>
                            </div>
                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-8 col-8 pl-1 pr-0">
                              <select
                                ref={classYearRef}
                                id="select_year"
                                data-testid="select_year"
                                className="ppClassYear pl-2 pr-4 py-0"
                                value={classYear}
                                onChange={(e) =>
                                  handlePPClassName(e.target.value, "ClassYear")
                                }
                                disabled={isEditing}
                                required
                                aria-required="true"
                                aria-invalid={errClassYear ? "true" : "false"}
                                aria-describedby={
                                  errClassYear ? CLASS_YEAR_ERROR_ID : undefined
                                }
                              >
                                {yearCollection != undefined
                                  ? yearCollection.map((yearsList) => {
                                      return <option>{yearsList}</option>;
                                    })
                                  : null}
                              </select>
                              {errClassYear && (
                                <span
                                  className="delePopup-colRed"
                                  id={CLASS_YEAR_ERROR_ID}
                                  
                                  role="alert"
                                >
                                  *Required
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3 mt-2">
                        <label
                          className="ppClassPopUpTxt"
                          htmlFor="input_class_description"
                        >
                          Class Description
                        </label>
                        <textarea
                          id="input_class_description"
                          data-testid="input_class_description"
                          className=" form-control rounded-0 ppClassNameInBox"
                          rows="4"
                          maxlength="300"
                          value={classDescription}
                          onChange={(e) =>
                            handlePPClassName(
                              e.target.value,
                              "ClassDescription",
                            )
                          }
                        />
                        <div className="classNameCnt countView ">
                          <span className="classNameValCountText inputCountTextdes">
                            {classDescCount}
                          </span>
                        </div>
                      </div>
                      <div className="text-right">
                        <button
                          className="btn btn-primary rounded-0 ppClassCancel px-3 py-1"
                          onClick={() => handleClassCancelBtn()}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary rounded-0 ppClassCancel px-3 py-1 ml-2"
                          onClick={() => handlePPClassSubmitBtn()}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                    className="modal fade"
                    show={showPPClassDeletePopUp}
                    onHide={() => setshowPPClassDeletePopUp(false)}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  >
                    <div className="ppclassDeletePopUp">
                      <p className="deleteClassPopUp-title">
                        The class and its related information will be
                        permanently removed. You will no longer have access to
                        the student details for this particular class.
                      </p>
                      <p className="deleteClassPopUp-text">
                        Do you want to delete this class?
                      </p>
                      <div className="text-center">
                        <button
                          className="btn btn-primary px-4 py-1 deletePopup-noBtn"
                          onClick={() => setshowPPClassDeletePopUp(false)}
                        >
                          No
                        </button>
                        <button
                          className="btn btn-light px-4 py-1 deletePopup-yesBtn ml-3"
                          onClick={() => deletePPClass()}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                    className="modal fade"
                    show={showPPClassEditPopUp}
                    onHide={() => setshowPPClassEditPopUp(false)}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  >
                    <div className="ppclassDeletePopUp">
                      <p className="deleteClassPopUp-title">
                        You have changed the class details.
                      </p>
                      <p className="deleteClassPopUp-text">
                        Do you want to save the changes?
                      </p>
                      <div className="text-center">
                        <button
                          className="btn btn-primary px-4 py-1 deletePopup-noBtn"
                          onClick={() => [
                            setshowPPClassEditPopUp(false),
                            setClassName(""),
                            setClassSemester(""),
                            setClassDescription(""),
                          ]}
                        >
                          No
                        </button>
                        <button
                          className="btn btn-light px-4 py-1 deletePopup-yesBtn ml-3"
                          onClick={() => updatePPClass()}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                    className="modal fade PPProfWelcomePopup"
                    contentClassName="p-4"
                    show={isShowProfessorWelcomePopup}
                    onHide={() => hideProfessorWelcomePopup()}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  >
                    <div className="ppclassProfWelcomePopUp">
                      <Modal.Header>
                        <Modal.Title className="ProfWelcomePopupTitle">
                          What's New?
                        </Modal.Title>
                        <Modal.Header closeButton />
                      </Modal.Header>
                      <Modal.Body className="p-0">
                        <p className="PPWelProfPopupTxt mb-2">
                          You can now create classes and view the performance of
                          your students on quizzes in PracticePerfect.{" "}
                          <a
                            href="#"
                            onClick={() => {
                              hideProfessorWelcomePopup();
                              handleAddClassBtn();
                            }}
                          >
                            <u>Try it now!</u>
                          </a>
                        </p>
                        <div className="row">
                          <div className="PPWelProfPopupTxt col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            With the new features you can:
                            <ul className="fa-ul">
                              <li>
                                <i className="fa-li fa fa-check PPWelLicolor"></i>{" "}
                                View a list of students who completed a quiz.
                              </li>
                              <li>
                                <i className="fa-li fa fa-check PPWelLicolor"></i>{" "}
                                View the average score, the highest score, and
                                the lowest score obtained on a quiz.
                              </li>
                              <li>
                                <i className="fa-li fa fa-check PPWelLicolor"></i>{" "}
                                View questions with which the students are
                                struggling.
                              </li>
                              <li>
                                <i className="fa-li fa fa-check PPWelLicolor"></i>{" "}
                                View the distribution of students' responses for
                                a question.
                              </li>
                            </ul>
                            Click{" "}
                            <a
                              href="https://support.aspenpublishing.com/hc/en-us/articles/18000255291540"
                              target="_blank"
                              onClick={() =>
                                setIsShowProfessorWelcomePopup(false)
                              }
                            >
                              <u>here</u>
                            </a>{" "}
                            to learn more.
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <img
                              className="w-100 PPProfWelcomeImage"
                              alt="Professor Class View"
                              src={PPWelcomeImage}
                            />
                          </div>
                        </div>
                        <div className="PPProfWelChecboxDivBottom">
                          <label style={{ marginTop: "5px" }}>
                            <input
                              data-testid="stop_welcome_popup"
                              type="checkbox"
                              onChange={(event) =>
                                setIsShowProfessorWelcomePopupCheckbox(
                                  event.target.checked,
                                )
                              }
                              value=""
                            />{" "}
                            Do not show this message again
                          </label>
                          <button
                            style={{ float: "right" }}
                            className="btn btn-primary rounded-0 ppClassCancel px-3 py-1 ml-2"
                            onClick={() => hideProfessorWelcomePopup()}
                          >
                            Got it
                          </button>
                        </div>
                      </Modal.Body>
                    </div>
                  </Modal>
                  <Modal
                    className="modal fade PPProfWelcomePopup"
                    contentClassName="p-4"
                    show={isShowProfQuizResetPopup}
                    onHide={() => setShowProfQuizResetPopup(false)}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
                  >
                    <div className="ppProfQuizResetPopUp">
                      <Modal.Header>
                        <Modal.Title className="ProfWelcomePopupTitle">
                          Your quizzes have been updated
                        </Modal.Title>
                        <button
                          data-testid="close_prof_quiz_reset"
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          ref={ppQuizResetPopupFocus}
                          onClick={() => setShowProfQuizResetPopup(false)}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </Modal.Header>
                      <Modal.Body className="p-0">
                        <p className="PPWelProfPopupTxt mb-2 pt-3">
                          We regret to inform you that there was an editorial
                          error in the following quizzes, which requires us to
                          update the following quizzes. The below-mentioned
                          questions have been removed to maintain the highest
                          quality content on our platform. Therefore, if your
                          students have already attempted any of the quizzes or
                          are currently in the process of attempting them, their
                          scores will be recalculated. We apologize for the
                          inconvenience this has caused and appreciate your
                          understanding.
                        </p>
                        <br></br>
                        <p>List of the questions that were deleted:</p>
                        <ol className="pl-3">
                          {isResetNotificationData != undefined
                            ? isResetNotificationData.map(
                                (resetChapterData) => {
                                  return (
                                    <li>
                                      <p>{resetChapterData.Message}</p>
                                    </li>
                                  );
                                },
                              )
                            : null}
                        </ol>
                        <div className="PPProfWelChecboxDivBottom mt-5">
                          <label style={{ marginTop: "5px" }}>
                            <input
                              data-testid="stop_notification_message"
                              type="checkbox"
                              onChange={() => updatePPRestNotification(3)}
                              value=""
                            />{" "}
                            Do not show this message again
                          </label>
                          <button
                            style={{ float: "right" }}
                            className="btn btn-primary rounded-0 ppProfQuizUpdatedPopup px-3 py-1 ml-2"
                            onClick={() => setShowProfQuizResetPopup(false)}
                          >
                            OK
                          </button>
                        </div>
                      </Modal.Body>
                    </div>
                  </Modal>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withAuth(PPClasses);
